// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IItemTypeWrapper {
  format_version: string;
}
